import React, { Component } from 'react';
import ScrollPercentage from 'react-scroll-percentage';
import styles from './Footer.css';
import { Icon } from '../../constants/consts-types';
import Svg from '../Svg/Svg';
import PropTypes from 'prop-types';
import { TypeFooter } from '../../constants/consts-prop-types';
import { setCookie } from '../../services/service-cookies';
import { LIB } from "../../constants/consts-types";
import {WP_BASE_API} from '../../services/service-wp'

const newsletterString = 'closeNewsletterPopUp';
const renderMenuLink = (route) => {
	return (
		<li key={route.title}>
			<a href={route.link} title={`${LIB.goto} ${route.title}`} className={styles.menuListItem}>
				<h1>{route.title}</h1>
			</a>
		</li>
	);
};

const renderLinkAfterAddress = (link, idx) => (
	<li key={idx}>
		<a href={link.link} title={`${LIB.goto} ${link.title}`}>{link.title}</a>
	</li>
);

class Footer extends Component {
	static propTypes = {
		data: TypeFooter,
		theme: PropTypes.string,
		isThy: PropTypes.bool
	};

	constructor(props) {
    super(props);

    this.state = {
			loading: false,
      email: "",
		};
		
		this.handelEmailAddress = this.handelEmailAddress.bind(this);
	}
	
	lib_define = {
    placeholder: LIB.popup_newsletter_placeholder,
    link_text: LIB.popup_newsletter_link_text,
    close_text: LIB.popup_newsletter_close,
    audience_id: "6f2ae9bb04"
  };

	ActivateSubscription = (event) => {
		event.preventDefault();
		setCookie(newsletterString, 'true', 365);
		this.props.newsletter(true);
	};

	handelEmailAddress(e) {
    this.setState({ email: e.target.value });
	}
	
	formSubmit = chimp => event => {
    event.preventDefault();
    
    this.setState({loading: true})

    fetch(
      `${WP_BASE_API}/api/chimp`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          audience_id: chimp.audience_id,
          email_address: this.state.email,
          status: "subscribed",
          merge_fields: {
            FNAME: "",
            LNAME: "",
          }
        })
      }
      )
      .then(res => {
				this.ActivateSubscription(event);
				return res.json()
      })
      .then(res => {
        console.log(res)
        this.setState({ Subscribe: true, loading: false});
      })
      .catch(err => {
        this.setState({loading: false})
        console.error("THERE WAS AN ERROR");
        console.log(Object.entries(err));
        console.log(err)
      });


    return false;
	};

	render() {
		const { theme, data, section, isThy } = this.props;

		const { text, menu, address, links_after_address } = data;

		const styleBgColor = {
			backgroundColor: theme !== 'dark' ? '#F5F5F5' : '#333333',
			color: theme !== 'dark' ? '#333333' : '#F5F5F5'
		};
		/*
		const mailchimp = this.lib_define

		const {
      placeholder,
      link_text,
		} = mailchimp;
		*/
		return (
			<ScrollPercentage>
				{({ percentage }) => (
					section === "SMK Guide" ? null :
					<footer className={styles.Footer} style={styleBgColor}>
						<div className={Boolean(percentage > 0) ? styles.contentShow : styles.content}>
							<div>
								<div className='container-fluid'>
									<div className='row'>
										<div className='col-xs-12 col-md-4'>
											<p dangerouslySetInnerHTML={{__html: text}} />

										</div>
										<div className='col-xs-12 col-md-5'>
											{menu && menu.length > 0 && <ul className={styles.menuList}>
												{menu.map(renderMenuLink)}
											</ul>}
										</div>
										<div className='col-xs-12 col-md-3'>
											<address dangerouslySetInnerHTML={{ __html: address }} />
											{links_after_address && <ul className={styles.addressLinks}>
												{links_after_address.map((link, idx) =>
														renderLinkAfterAddress(link, idx)
													)}
											</ul>}
										</div>
									</div>
								</div>
							</div>

							<div>
								<div className='container-fluid'>
									<div className='row'>
										<div className='col-xs-12 col-md-4'>
											<div className={styles.logos}>
                          <Svg
                            id={isThy ? Icon.LOGO_THY_FRAME : Icon.LOGO_FRAME}
                            style={{ marginBottom: "-18px" }}
                          />
												{!isThy && <Svg id={Icon.Parkmuseerne} />}
											</div>
										</div>
										<div className='col-xs-12 col-md-5' />
										{/*<div className="col-xs-12 col-md-3">
                      <div className={styles.logos}>
                        <Svg id={Icon.LOGO_NORDEA_FONDEN}/>
                      </div>
                    </div>*/}
									</div>
								</div>
							</div>
						</div>
					</footer>
				)}
			</ScrollPercentage>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js